import { zUsdCents } from "@redotech/money/usd-amounts";
import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateDimensionalPackagingBillingSettings = {
  name: "updateDimensionalPackagingBillingSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    subscriptionBilling: z
      .object({
        enabled: z.boolean(),
        renewOnPeriodEnd: z.boolean(),
        startDate: z.date().optional(),
        /** DEPO is monthly-only, and bills through Stripe only. */
        period: z.literal(BillingPeriod.MONTHLY),
        periodFeeInCents: zUsdCents.refine(
          (cents) => Number.isInteger(cents) && cents >= 0,
          "Period fee must be a whole number of cents",
        ),
      })
      .refine(
        (billing) => !billing.enabled || billing.periodFeeInCents > 0,
        "Period fee must be positive when billing is enabled",
      )
      /** Without a start date the engine logs and never bills the team. */
      .refine(
        (billing) => !billing.enabled || billing.startDate != null,
        "Start date is required when billing is enabled",
      ),
  }),
  output: z.null(),
};

export type UpdateDimensionalPackagingBillingSettingsInput = z.infer<
  typeof updateDimensionalPackagingBillingSettings.input
>;
